import type { AutomationActionType } from '../types/AutomationWorkflow.types';

export type AutomationBranchActionType = Exclude<
  AutomationActionType,
  'if_else' | 'run_agent'
>;

export type AutomationBranchAction = {
  type: AutomationBranchActionType;
  config: Record<string, unknown>;
};

export type IfElseNodeConfig = {
  conditionField: 'bpm';
  minBpm: number;
  maxBpm: number;
  trueBranch: AutomationBranchAction;
  falseBranch: AutomationBranchAction;
};

export const defaultBranchAction = (
  type: AutomationBranchActionType = 'add_to_serato_crate',
): AutomationBranchAction => ({
  type,
  config: type === 'add_to_serato_crate' ? { crateName: '' } : {},
});

export const defaultIfElseConfig = (): IfElseNodeConfig => ({
  conditionField: 'bpm',
  minBpm: 120,
  maxBpm: 128,
  trueBranch: defaultBranchAction('add_to_serato_crate'),
  falseBranch: defaultBranchAction('add_to_serato_crate'),
});

export const parseIfElseConfig = (
  config: Record<string, unknown>,
): IfElseNodeConfig => {
  const defaults = defaultIfElseConfig();
  const readBranch = (
    key: 'trueBranch' | 'falseBranch',
  ): AutomationBranchAction => {
    const raw = config[key];
    if (!raw || typeof raw !== 'object') return defaults[key];
    const branch = raw as AutomationBranchAction;
    return {
      type: branch.type ?? defaults[key].type,
      config: { ...defaults[key].config, ...(branch.config ?? {}) },
    };
  };

  return {
    conditionField: 'bpm',
    minBpm: Number(config.minBpm ?? defaults.minBpm),
    maxBpm: Number(config.maxBpm ?? defaults.maxBpm),
    trueBranch: readBranch('trueBranch'),
    falseBranch: readBranch('falseBranch'),
  };
};

export const BRANCH_ACTION_LABELS: Record<AutomationBranchActionType, string> =
  {
    add_to_serato_crate: 'Add to Serato crate',
    copy_move_file: 'Copy / move file',
    import_to_library: 'Import to library',
    read_write_tags: 'Read / write tags',
  };
